/**
 * «Certificado de antigüedad» en Mi ficha (#1491).
 *
 * Autoservicio: lo emite al instante, sin aprobación, porque son datos que la
 * persona ya conoce. Queda guardado en Mis documentos → Certificados, y si se
 * pide dos veces el mismo día el backend devuelve el mismo.
 *
 * Se muestra en el visor, desde donde se descarga. ⚠️ La emisión va DENTRO de
 * `cargar` y no antes de `ver`: en el celular el visor es una pestaña nueva, y
 * abierta después de un `await` el navegador la bloquea como ventana emergente.
 */
import { useLocation } from 'react-router-dom'
import { FileBadge } from 'lucide-react'
import apiClient from '@/lib/apiClient'
import { portalApiClient } from '@/store/portalAuthStore'
import { Button } from '@/components/ds/Button'
import { useToast } from '@/components/Toast'
import { documentoGuardado, useVisorPdf } from '@/components/VisorPdf'
import { extractErrorMessage } from '@/lib/errorUtils'

export function BotonCertificadoAntiguedad() {
  const { pathname } = useLocation()
  const client = pathname.startsWith('/colaboradores') ? portalApiClient : apiClient
  const toast = useToast()
  const { ver, visor } = useVisorPdf()

  const emitir = () => {
    let docId = ''
    const guardado = () => documentoGuardado(client, `/employee/documents/${docId}/download/`)
    ver({
      titulo: 'Certificado de antigüedad',
      nombreArchivo: 'certificado_de_antiguedad.pdf',
      cargar: async () => {
        try {
          const { data } = await client.post('/employee/certificado-antiguedad/')
          docId = data.document_id
        } catch (e) {
          toast.error(extractErrorMessage(e, 'No se pudo emitir el certificado.'))
          throw e
        }
        toast.success('Certificado listo. También queda en Mis documentos → Certificados.')
        return guardado().cargar()
      },
      urlDeDescarga: () => guardado().urlDeDescarga!(),
    })
  }

  return (
    <>
      <Button size="sm" variant="secondary" onClick={emitir}
        icon={<FileBadge size={14} aria-hidden="true" />}>
        Certificado de antigüedad
      </Button>
      {visor}
    </>
  )
}
